import React, { lazy } from "react";

import { VIEW_IU_VERSIONS_PERMISSION } from "constants/permissions";

const IUVersionPage = lazy(() => import("./IUVersionPage"));

const iuVersionsRoute = {
  path: "iu_versions",
  element: <IUVersionPage />,
  root: true,
  permission: VIEW_IU_VERSIONS_PERMISSION,
};

export default iuVersionsRoute;
